<template>
  <div
    class="pentagon-candle-pair"
    :class="{ 'pentagon-candles--paused': hidden }"
    aria-hidden="true"
  >
    <candle side="left" uid="candle-left" :phase="phase" />
    <candle side="right" uid="candle-right" :phase="phase" />
  </div>
</template>

<script>
import Candle from './Candle.vue';

export default {
  name: 'CandlePair',
  components: {
    Candle,
  },
  data() {
    return {
      hidden: typeof document !== 'undefined' && document.hidden,
    };
  },
  computed: {
    phase() {
      return this.$store.state.candles.phase;
    },
  },
  mounted() {
    document.addEventListener('visibilitychange', this.onVisibilityChange);
  },
  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.onVisibilityChange);
  },
  methods: {
    onVisibilityChange() {
      this.hidden = document.hidden;
    },
  },
};
</script>

<style>
.pentagon-candle-pair {
  --pentagon-candle-width: clamp(14px, 1.2vw + 8px, 22px);
  --pentagon-candle-edge: clamp(4px, 1vw, 14px);
  --pentagon-candle-top: 18vh;
  --pentagon-glow-opacity: 1;

  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 20;
  overflow: hidden;
  pointer-events: none;
}

@media (max-width: 575.98px) {
  .pentagon-candle-pair {
    --pentagon-candle-width: 14px;
    --pentagon-candle-edge: 4px;
    --pentagon-glow-opacity: 0.6;
  }
}

@media (max-height: 500px) {
  .pentagon-candle-pair {
    --pentagon-candle-top: 90px;
  }
}

.pentagon-candles--paused .pentagon-candle,
.pentagon-candles--paused .pentagon-candle * {
  animation-play-state: paused !important;
}
</style>
